import {$, w} from './constants';

import './cookies';
import './menu';
import './buttons';



w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

})

document.body.addEventListener('touchstart', function(e){ e.preventDefault(); });

// // // // Ajusta tamaño textarea 
// var textarea = document.querySelector('textarea');

// textarea.addEventListener('keydown', autosize);
// function autosize(){
// 	var el = this;
// 	setTimeout(function(){
// 		el.style.cssText = 'height:auto; padding:0';
// 		el.style.cssText = 'height:' + el.scrollHeight + 'px';
// 	},0);
// }




// WEBPACK FOOTER //
// ./es6/micorriza.js